import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Link} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import CategoriesList from './categories-list';
import PageTitle from '../../../../common/page-title/index';
import ArrowButton from '../../../../common/button-arrow';
import {getCategories} from '../../../../../actions/news';

import './styles.css';

class Categories extends Component {
  state = {
    query: ''
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(actions.reset('deep.admin_news.category'));
    this.props.dispatch({type: 'CLEAR_EDIT_NEWS_CATEGORY'});
    this.props.dispatch(getCategories());
  }

  render() {
    return (
      <Container fluid className="news">
        <PageTitle>
          News Categories
        </PageTitle>
        <Link to="/admin/news/categories/new">
          <ArrowButton
            arrow={false}
            className="add-category"
            color="red"
            permissions={{
              action: 'create',
              subjectClass: 'NewsCategory',
            }}
            submit={false}
          >
            Add category
          </ArrowButton>
        </Link>

        <CategoriesList
          categories={this.props.categories}
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          onReorder={this.handleSearch}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.news.categories.categories,
  fetched: state.news.categories.fetched,
  fetching: state.news.categories.fetching,
});

export default connect(mapStateToProps)(Categories);
